import React from "react";
import AudienceListItem from "../AudienceListItem/AudienceListItem";
import { Box } from "@tiny/components";
import { AudienceSourceProps } from "./AudienceSource.types";

const AudienceSource = (props: AudienceSourceProps) => {
  const {
    items,
    sourceParentBoxRef,
    draggingItem,
    handleDragStart,
    handleDragOver,
    handleDrop,
  } = props;

  return (
    <Box ref={sourceParentBoxRef}>
      {items.map((audience) => (
        <Box
          key={audience.id}
          draggable
          className={`item ${audience === draggingItem ? "dragging" : ""}`}
          onDragStart={(e) => handleDragStart(e, audience)}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, audience)}
        >
          <AudienceListItem audience={audience} />
        </Box>
      ))}
    </Box>
  );
};

export default AudienceSource;
